// React Core Imports
import { useState } from 'react'

const MapIframe = ({
  title,
  src,
  className,
  placeholderSrc,
  placeholderAlt = 'Mapa',
  revealDelay = 500, // ms – můžeš si doladit (200–500 funguje dobře)
}) => {
  const [loaded, setLoaded] = useState(false)
  const [revealed, setRevealed] = useState(false)

  const handleLoad = () => {
    setLoaded(true)
    setTimeout(() => {
      setRevealed(true)
    }, revealDelay)
  }

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        background: '#F5F1EE',
      }}
    >
      {/* Placeholder */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          opacity: revealed ? 0 : 1,
          transition: 'opacity 400ms ease',
          pointerEvents: 'none',
        }}
      >
        {placeholderSrc ? (
          <img
            src={placeholderSrc}
            alt={placeholderAlt}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'left top',
              display: 'block',
            }}
          />
        ) : (
          <div
            aria-hidden='true'
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(90deg, #F5F1EE, #FAF7F5, #F5F1EE)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.2s infinite',
            }}
          />
        )}
      </div>

      {/* Iframe */}
      <iframe
        title={title}
        src={src}
        loading='lazy'
        onLoad={handleLoad}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
          opacity: revealed ? 1 : 0,
          transition: 'opacity 400ms ease',
        }}
      />

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  )
}

export default MapIframe
